import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {MerchantListComponent} from './merchant-list.component';
import {NgxSpinnerService} from 'ngx-spinner';
import {MerchantsService} from './merchants-service';
import {HttpErrorValidator} from '../services/http-error-validator';
import {IMerchant, IResultados} from './IMerchant';
import {Router} from '@angular/router';

@Component({
  selector: 'pm-edit-merchant',
  templateUrl: './edit-merchant.component.html',
  styleUrls: ['./edit-merchant.component.sass']
})
export class EditMerchantComponent implements OnInit, OnDestroy, AfterViewInit {
  Comercio: IMerchant;
  errorMessage = '';
  ownershipTypes: IResultados[] = [];
  mcc: IResultados[] = [];
  estadosDeComercio: IResultados[] = [];
  estadosDeComercioDetail: IResultados[] = [];
  monedas: IResultados[] = [];
  paises: IResultados[] = [];
  estadosPaisComercio: IResultados[] = [];
  estadosPaisPropietario: IResultados[] = [];
  estadosPaisFirmante: IResultados[] = [];

  constructor(private parent: MerchantListComponent, private spinnerService: NgxSpinnerService,
              private httpErrorValidator: HttpErrorValidator,
              private router: Router,
              private comerciosService: MerchantsService) {
  }

  ngOnInit(): void {
    this.spinnerService.show();
    this.getComercio(this.parent.editnumber);
  }

  tipoPropietario(): void {
    this.comerciosService.getOwnershiptypes().subscribe(response => {
      this.ownershipTypes = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getMCC(): void {
    this.comerciosService.getMCC().subscribe(response => {
      this.mcc = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getEstadosComercio(): void {
    this.comerciosService.getSellerstatus().subscribe(response => {
      this.estadosDeComercio = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getEstadosPaisComercio(): void {
    this.comerciosService.getEstadosPais(this.Comercio.seller.sellerStreetAddress.countryCode).subscribe(response => {
      this.estadosPaisComercio = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getEstadosPaisPropietario(): void {
    this.comerciosService.getEstadosPais(this.Comercio.significantOwner.streetAddress.countryCode).subscribe(response => {
      this.estadosPaisPropietario = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getEstadosPaisFirmante(): void {
    this.comerciosService.getEstadosPais(this.Comercio.significantOwner.streetAddress.countryCode).subscribe(response => {
      this.estadosPaisFirmante = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getDetalleEstadosComercio(): void {
    this.comerciosService.getSellerstatusDetail().subscribe(response => {
      this.estadosDeComercioDetail = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getCurrencies(): void {
    this.comerciosService.getCurrencies().subscribe(response => {
      this.monedas = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  getPaises(): void {
    this.comerciosService.getCountries().subscribe(response => {
      this.paises = response;
      this.getEstadosPaisComercio();
      this.getEstadosPaisPropietario();
      this.getEstadosPaisFirmante();
      this.spinnerService.hide();
    }, err => this.httpErrorValidator.validateError(err));
  }

  getComercio(id: number): any {
    this.comerciosService.getComercio(id).subscribe(comercio => {
        this.Comercio = comercio;
        this.tipoPropietario();
        this.getMCC();
        this.getEstadosComercio();
        this.getDetalleEstadosComercio();
        this.getCurrencies();
        this.getPaises();
      },
      error => (this.errorMessage = error as any));
  }

  ngOnDestroy(): void {
    $('a[rel=comercios]').removeClass('selected');
  }

  ngAfterViewInit(): void {
    $('a[rel=comercios]').addClass('selected');
  }

  cancelarComercio(): void {
    this.parent.showComercios = true;
    this.parent.showEditComercios = false;
  }

  guardarCambios(): void {
    this.Comercio.requestId = 'null';
    this.comerciosService.formData = this.Comercio;
    this.comerciosService.updateComercio().subscribe(
      res => {
        const setupErrors = this.comerciosService.getSetupErrors(res);

        if (setupErrors.length > 0) {
          alert('No se actualizó el comercio:\n\n' + setupErrors.join('\n'));
          return;
        }

        this.parent.showComercios = true;
        this.parent.showEditComercios = false;
        this.router.navigate(['/comercios']);
      },
      err => {
        this.httpErrorValidator.reportError(err, 'No se actualizó el comercio');
      }
    );
  }
}
